<template>
    <DiscountCode :configuration="configuration"></DiscountCode>
	<div class="UserForm-title UserForm-item--full" v-if="gift" >Dostanete ještě navíc dárek!</div>
	<BaseAlert v-if="gift" :type="'success'">
		<span>{{ gift?.title }}</span>
	</BaseAlert>
	<form class="UserForm" @submit.prevent="onSubmit">
        <div class="UserForm-item UserForm-item--full">
            <BaseCheckBox label="Nákup je prováděn na firmu nebo podnikající osobu" v-model="companyOrder" inline />
        </div>
        <template v-if="companyOrder">
            <div class="UserForm-title UserForm-item--full">Fakturační údaje</div>
            <div class="UserForm-item">
                <BaseInput type="text" v-model="billingFirstName" label="Křestní jméno" required/>
            </div>
            <div class="UserForm-item">
                <BaseInput type="text" v-model="billingLastName" label="Příjmení" required/>
            </div>
            <div class="UserForm-item UserForm-item--full">
                <BaseInput type="text" label="Firma" v-model="billingCompany" required />
            </div>
            <div class="UserForm-item">
                <BaseInput type="text" label="IČ" v-model="billingCompanyId" required />
            </div>
            <div class="UserForm-item">
                <BaseInput type="text" label="DIČ" v-model="billingCompanyVatId" required />
            </div>
            <div class="UserForm-item UserForm-item--full">
                <BaseInput type="text" v-model="billingAddress" label="Ulice a číslo" required/>
            </div>
            <div class="UserForm-item">
                <BaseInput type="text" v-model="billingCity" label="Obec" required/>
            </div>
            <div class="UserForm-item">
                <BaseInput type="text" v-model="billingPostalCode" label="PSČ" required pattern="[0-9 ]+"/>
            </div>
            <div class="UserForm-item">
                <BaseInput type="email" v-model="billingEmail" label="E-mail" required/>
            </div>
            <div class="UserForm-item">
                <BaseInput type="text" v-model="billingPhone" label="Telefon" required pattern="[0-9 +]+"/>
            </div>
        </template>
        <div class="UserForm-title UserForm-item--full">Kontaktní osoba</div>
		<div class="UserForm-item">
			<BaseInput type="text" v-model="customerFirstName" label="Křestní jméno" required/>
		</div>
		<div class="UserForm-item">
			<BaseInput type="text" v-model="customerLastName" label="Příjmení" required/>
		</div>
		<div class="UserForm-item">
			<BaseInput type="email" v-model="customerEmail" label="E-mail" required/>
		</div>
		<div class="UserForm-item">
			<BaseInput type="text" v-model="customerPhone" label="Telefon" required pattern="[0-9 +]+"/>
		</div>
        <div class="UserForm-title UserForm-item--full">Místo realizace</div>
		<div class="UserForm-item UserForm-item--full">
			<BaseInput type="text" v-model="locationAddress" label="Ulice a číslo" required/>
		</div>
		<div class="UserForm-item">
			<BaseInput type="text" v-model="locationCity" label="Obec" required/>
		</div>
		<div class="UserForm-item">
			<BaseInput type="text" v-model="locationPostalCode" label="PSČ" required pattern="[0-9 ]+"/>
		</div>
        <div class="UserForm-title UserForm-item--full"></div>
		<div class="UserForm-item">
			<BaseInput type="date" label="Předpokládaný termín zahájení" v-model="start" required/>
		</div>
		<div class="UserForm-item">
			<BaseInput type="date" label="Předpokládaný termín dokončení" v-model="completion" required/>
		</div>
		<div class="UserForm-item UserForm-item--full">
			<div class="UserForm-title">Dokumentace a poznámky</div>
			<BaseFileInput
				@change="processFile($event)"
                :file="file"
				:label="'Máte soubory s dokumentací? Rovnou je přiložte k poptávce'"
				accept=".pdf,.docx,.xlsx,.jpg,.png"
				name="file"/>
		</div>
		<div class="UserForm-item UserForm-item--full">
			<BaseFileInput
				@change="processFile($event)"
                :file="file2"
				accept=".pdf,.docx,.xlsx,.jpg,.png"
				name="file2"/>
		</div>
		<div class="UserForm-item UserForm-item--full">
			<BaseFileInput
				@change="processFile($event)"
                :file="file3"
				accept=".pdf,.docx,.xlsx,.jpg,.png"
				name="file3"/>
		</div>
		<div class="UserForm-item UserForm-item--full">
			<BaseTextArea v-model="question" :label="'Máte dotaz? Napište nám zprávu'"/>
		</div>
        <template v-if="$route.name === 'garden-conf-whole' || $route.name === 'garden-conf-part'">
            <div class="UserForm-item UserForm-item--full">
                <div class="UserForm-title">Předpokládaná cena realizace Vaší zahrady</div>
                <p class="UserForm-perex">Částku, kterou chcete do zahrady investovat, chceme znát proto, abychom Vám zbytečně nenavrhovali zahradu, která bude mimo Vaše finanční možnosti, či naopak se nedrželi moc u země, když Vaše představy budou megalomanské.</p>
                <BaseInput type="number" label="Předpokladaná cena (Kč)" v-model="assumedPrice" required/>
            </div>
            <div class="UserForm-item UserForm-item--full">
                <BaseInput type="text" label="Poznámka k ceně realizace" v-model="assumedPriceNote"/>
            </div>
        </template>
        <div class="UserForm-item UserForm-item--full">
            <div class="ThanksBox">
                <p class=" UserForm-title">Děkujeme, že jste si udělali čas a využili naší "Zelené kalkulačky".</p>
                <p><strong>Budeme se těšit na schůzku s Vámi.</strong></p>
                <p>Rádi se dozvíme, jak se Vám s námi online pracovalo. Máte pro nás návrhy na zlepšení? Byli jste z něčeho nadšeni?</p>
                <BaseTextArea v-model="rating" :label="'Podělte se s námi. Děkujeme vám'"/>
            </div>
        </div>
		<div class="UserForm-item UserForm-item--full">
			<div class="UserForm-gdpr">Beru na vědomí <a href="https://zelenekolo.cz/prohlaseni-o-nakladani-s-osobnimi-udaji/" target="_blank" rel="noopener">zpracování osobních údajů</a>.</div>
		</div>
        <BaseAlert class="u-spanRow" v-if="formState.message" :type="formState.success ? 'success' : 'error'">{{formState.message}}</BaseAlert>
		<UserFormActions v-if="!formState.sent" @submittedWithPdf="submittedWithPDF = $event"></UserFormActions>
	</form>
</template>

<script>
import {reactive, toRefs, inject, ref, onMounted} from 'vue';
	import UserFormActions from './UserFormActions.vue';
    import BaseCheckBox from "./Base/BaseCheckBox";
    import DiscountCode from "@/components/DiscountCode";

	export default {
		name: 'UserForm',
		components: {
            DiscountCode,
            BaseCheckBox,
			UserFormActions
		},
        props: {
            configuration: Object,
			gift: Object,
        },
		setup (props) {
			// console.log(props.gift)
			const formState = inject('formState');
			const formData = inject('userFormData');
			const onFormSubmitted = inject('onFormSubmitted');
			const submittedWithPDF = ref(false);
            const companyOrder = ref(false);

            const onSubmit = () => {
                !companyOrder.value && Object.keys(formData).filter(key => key.includes('billing')).forEach(key => {
                    if (formData[key]) formData[key] = '';
                });

				onFormSubmitted(formData, submittedWithPDF.value);
			}

			const processFile = event => {
				const files = event.target.files;
				if (files.length) {
					formData[event.target.name] = files[0];
				} else {
					formData[event.target.name] = null;
				}
			}

			return {
				...toRefs(formData),
				onSubmit,
				processFile,
				formState,
                submittedWithPDF,
                companyOrder,
			}
		}
	}

</script>

<style lang="scss" scoped>
.DiscountCode {
    margin-bottom: 2rem;
}

.UserForm {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;

	:deep(label) {
		font-size: 1.1em;
	}

	&-item {
		width: 48%;
		margin-bottom: 1.5em;
		@media (max-width: 500px) {
			width: 100%;
		}

		&--full {
			width: 100%;
		}
	}

	&-title {
		font-size: var(--textLg);
		font-weight: 700;
		margin: .5em 0 1em;
		color: var(--colorBrandDark);
	}

	&-perex {
		line-height: 1.7;
	}

	&-gdpr {
		text-align: right;
		a {
			color: var(--colorBrandDark);
			
			&:hover {
				color: #000;
				text-decoration: none;
			}
		}
	}

	&-note {
		font-weight: 700;
		font-size: .8em;
		margin-top: 1em;
	}

}

.ThanksBox {
    border-top: 2px solid var(--colorBrandLighten);
    padding-top: 1.2em;
    margin-top: 1em;

}
</style>